/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 地址管理
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';
@BindAll()
export class AddressController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: false,
      pagination: EnumAPI.bffsvr_address,
      details: EnumAPI.bffsvr_address_details,
      insert: EnumAPI.bffsvr_address_add,
      update: EnumAPI.bffsvr_address_update,
      delete: EnumAPI.bffsvr_address_delete,
      paginationParams: {
        response: {
          valueGetter: this.valueGetter,
        },
      },
    });
  }
  private valueGetter(response) {
    const dataSource = lodash.map(lodash.get(response, 'addressList'), (item) =>
      lodash.merge(item, {
        // isDefault: lodash.eq(item.isDefault, 1),
        name: item.consignee,
        tel: item.mobile,
        address: lodash
          .compact([
            lodash.get(item, 'provinceName'),
            lodash.get(item, 'cityName'),
            lodash.get(item, 'countyName'),
            lodash.get(item, 'details'),
          ])
          .join(' / '),
      }),
    );
    // if (!lodash.find(dataSource, ['id', lodash.get(this.selectAddress, 'id')])) {
    //     this.onSelectAddress({})
    // }
    return {
      isIncludeSign: lodash.get(response, 'isIncludeSign'),
      dataSource,
    };
  }

  /**
   * @desc BPP 收货地址
   */
  @computed
  get BppDataSource() {
    return lodash.filter(this.dataSource, ['source', 'BPP-SMB']);
  }
  /**
   * @desc Sec 收货地址
   */
  @computed
  get SecDataSource() {
    return lodash.filter(this.dataSource, ['source', 'SEC']);
  }
  @computed
  get isIncludeSign(): boolean {
    return this.Pagination.Model.getStorage('response.isIncludeSign', false);
  }
  @computed
  public get selectAddress() {
    return this.Details.Model.getStorage('selectAddress', {}) || {};
    // return this.Details.Model.getStorage('selectAddress', this.Pagination.firstData) || {};
  }
  onSelectAddress(address) {
    this.Details.Model.setStorage('selectAddress', address);
  }
}
